import { Button } from '@onwardtravelsolutions/package-react/Components';
import { Paginator } from '@onwardtravelsolutions/package-react/Types';

type SimplePaginatorProps = {
    paginator: Paginator;
    className?: string;
};

export default function SimplePaginator({
    paginator,
    className = '',
}: SimplePaginatorProps) {
    const {
        navigateToPreviousPage,
        navigateToNextPage,
        isFirstPage,
        isLastPage,
        isPaginatable,
    } = paginator;

    const buttonClassName =
        'disabled:invisible inline-block border-neutral-300 text-neutral-700 dark:border-neutral-700 dark:text-neutral-200 text-base transition cursor-pointer font-semibold px-6 py-3 border rounded hover:bg-neutral-200 dark:hover:bg-neutral-700 text-sm';

    return (
        <>
            {isPaginatable && (
                <div
                    className={`flex justify-between items-center ${className}`}
                >
                    <Button
                        className={buttonClassName}
                        onClick={() => navigateToPreviousPage()}
                        disabled={isFirstPage}
                        aria-label='Go to previous page'
                    >
                        Previous
                    </Button>

                    <Button
                        className={buttonClassName}
                        onClick={() => navigateToNextPage()}
                        disabled={isLastPage}
                        aria-label='Go to next page'
                    >
                        Next
                    </Button>
                </div>
            )}
        </>
    );
}
